export default __webpack_public_path__ + "static/media/python.7507500e.svg";